export var PermissionStatus;
(function (PermissionStatus) {
    PermissionStatus[PermissionStatus["unknown"] = 0] = "unknown";
    PermissionStatus[PermissionStatus["busy"] = 1] = "busy";
    PermissionStatus[PermissionStatus["allowed"] = 2] = "allowed";
    PermissionStatus[PermissionStatus["denied"] = 3] = "denied";
    PermissionStatus[PermissionStatus["banned"] = 4] = "banned";
})(PermissionStatus || (PermissionStatus = {}));
const CONTACT_PLACEHOLDERS = {
    company: '',
    emailAddresses: [],
    middleName: '',
    jobTitle: '',
    phoneNumbers: [],
    postalAddresses: [],
    prefix: '',
    suffix: '',
    department: '',
    birthday: {
        day: 0,
        month: 0,
        year: 0,
    },
    backTitle: '',
    displayName: '',
    imAddresses: [],
    note: '',
    isStarred: false,
    urlAddresses: [],
    isEmmaUser: true,
};
export const contactFromUserHandleInfo = (source) => ({
    ...CONTACT_PLACEHOLDERS,
    recordID: '',
    familyName: source.familyName ?? '',
    givenName: source.firstName ?? '',
    hasThumbnail: source.img !== undefined,
    thumbnailPath: source.img ?? '',
    handle: source.handle,
    hasSubscription: source.hasSubscription,
});
export const contactFromGroupUserResponse = (source) => {
    const nameToShow = source.firstName && source.lastName
        ? `${source.firstName} ${source.lastName}`
        : source.firstName || source.lastName || undefined;
    return {
        ...CONTACT_PLACEHOLDERS,
        recordID: `group-${source.id}`,
        familyName: source.lastName ?? '',
        givenName: source.firstName ?? '',
        hasThumbnail: !!source.profilePicUrl,
        thumbnailPath: source.profilePicUrl ?? '',
        handle: source.handle,
        hasSubscription: source.hasSubscription,
        nameToShow,
    };
};
export const contactFromSpaceMember = (source) => {
    const nameToShow = source.firstName && source.lastName
        ? `${source.firstName} ${source.lastName}`
        : source.firstName || source.lastName || undefined;
    return {
        ...CONTACT_PLACEHOLDERS,
        recordID: `space-${source.id}`,
        familyName: source.lastName ?? '',
        givenName: source.firstName ?? '',
        hasThumbnail: !!source.imageUrl,
        thumbnailPath: source.imageUrl ?? '',
        handle: source.handle,
        hasSubscription: source.hasSubscription,
        nameToShow,
    };
};
